import { Routes, Route } from 'react-router-dom'
import Home from '../pages/Home'
import Industrial from '../pages/Industrial'
import Lab from '../pages/Lab'
import Pharma from '../pages/Pharma'
import Climate from '../pages/Climate'
import Contacto from '../pages/Contacto'
import NotFound from '../pages/NotFound'


const AppRoutes = () => {
    return (
        <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/frio-industrial' element={<Industrial />} />
            <Route path='/laboratorio' element={<Lab />} />
            <Route path='/farmacia' element={<Pharma />} />
            <Route path='/climatizacion' element={<Climate />} />
            <Route path='/contacto' element={<Contacto />} />
            <Route path='*' element={<NotFound />} />
        </Routes>
    )
}

export default AppRoutes